export const ARTIST_ATTRIBUTION_LIMIT = 32;

export const DESKTOP_SLIDE_COUNT = 6;

export const MOBILE_SLIDE_COUNT = 2;

export const ARTIST_ATTRIBUTION_SEO_LINK_LIMIT = 14;
